/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-10 14:13:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-11 14:43:45
 * @FilePath: \zhucai_user\src\api\exam.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/util/request";

export function Exam_Create(data) {
  return request({
    url: "/pc/Exam/Exam_Create",
    method: "post",
    data,
  });
}
export function Exam_GetExamInfo(params) {
  return request({
    url: "/pc/Exam/Exam_GetExamInfo",
    method: "get",
    params,
  });
}
export function Exam_Mark(data) {
  return request({
    url: "/pc/Exam/Exam_Mark",
    method: "post",
    data,
  });
}

export function Exercise_Mark(data) {
  return request({
    url: "/pc/Exam/Exercise_Mark",
    method: "post",
    data,
  });
}
export function Exam_SaveAnswer(data) {
  return request({
    url: "/pc/Exam/Exam_SaveAnswer",
    method: "post",
    data,
  });
}
export function Exam_Hand(data) {
  return request({
    url: "/pc/Exam/Exam_Hand",
    method: "post",
    data,
  });
}
export function Exam_GetResult(params) {
  return request({
    url: "/pc/Exam/Exam_GetResult",
    method: "get",
    params,
  });
}
export function Exercise_GetDetail(params) {
  return request({
    url: "/pc/Exam/Exercise_GetDetail",
    method: "get",
    params,
  });
}

//练习接口
export function Exercise_Create(data) {
  return request({
    url: "/pc/Exam/Exercise_Create",
    method: "post",
    data,
  });
}
export function Exercise_GetExerciseInfor(params) {
  return request({
    url: "/pc/Exam/Exercise_GetExerciseInfor",
    method: "get",
    params,
  });
}
export function Exercise_SaveAnswer(data) {
  return request({
    url: "/pc/Exam/Exercise_SaveAnswer",
    method: "post",
    data,
  });
}
export function Exercise_Hand(data) {
  return request({
    url: "/pc/Exam/Exercise_Hand",
    method: "post",
    data,
  });
}
export function Exercise_Reset(data) {
  return request({
    url: "/pc/Exam/Exercise_Reset",
    method: "post",
    data,
  });
}
export function Exercise_GetResult(params) {
  return request({
    url: "/pc/Exam/Exercise_GetResult",
    method: "get",
    params,
  });
}
export function Wrong_GetExerciseInfor(params) {
  return request({
    url: "/pc/Exam/Wrong_GetExerciseInfor",
    method: "get",
    params,
  });
}
export function Wrong_SaveAnswer(data) {
  return request({
    url: "/pc/Exam/Wrong_SaveAnswer",
    method: "post",
    data,
  });
}
export function Wrong_Hand(data) {
  return request({
    url: "/pc/Exam/Wrong_Hand",
    method: "post",
    data,
  });
}
export function Wrong_GetResult(params) {
  return request({
    url: "/pc/Exam/Wrong_GetResult",
    method: "get",
    params,
  });
}
